export default __webpack_public_path__ + "static/media/statistiqueLogo.4ff66344.png";